import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import config from '../../../../application/config/config';
import { loadData } from '../Util/List/CustomList/loadData';
import { getUserSession } from "../../../util/core/Session";
import { useParams } from "react-router-dom";
import Toast from '../Util/Toast/Toast';

function Crud() {
  const session = getUserSession();
  const pathFrontEnd = '/core/examples/crud/dialog/';

  const listPaths = {
    pathAdd: pathFrontEnd + 'add',
    pathEdit: pathFrontEnd + 'edit',
    pathView: pathFrontEnd + 'view',
    endpointDelete: `${config.endpoints.backend}core/cruddialog/delete`,
    endpoint: config.endpoints.backend + 'core/cruddialog/getall'
  }

  const formPaths = {
    endpointSave: config.endpoints.backend + 'core/cruddialog/save',
    endpointGetById: config.endpoints.backend + 'core/cruddialog/getById',
    urlGoBack: pathFrontEnd  + 'list',
    pathView: pathFrontEnd  + 'view'
}

  const labels = {
    labelTitleAdd: "Novo Exemplo",
    labelTitleEdit: "Editar Exemplo",
    labelTitleView: 'Visualizar Exemplo'
  }

  let list = {
    type: 'dialog',
    labelTitle: 'Lista de exemplo (CRUD dialog)',
    labelTitleButtonAdd: 'Incluir exemplo',
    fieldsShowOnDelete: ['name'],
    buttonsListContainer: [
      {
        name: 'customized_button',
        class: 'btn btn-primary',
        label: 'Botão customizado',
        tooltipLabel: 'Botão customizado',
        icon: 'fa fa-plus', //can null
        callback: () => {
          console.log('Customizado')
        }
      }
    ],
    showPrintButtons: true,
    columns: [
      {
        name: 'name',
        label: 'Nome',
        sortable: true
      }
    ],
    ...listPaths
  };

  const form = {
    containerType:'dialog',
    validateOnChange: true,
    hiddenValues: {
      core_application_instance_id: session.user.application_instance_id,
      core_user_id: session.user.id
    },
    fields: [
      {
        name: 'slider',
        type: 'rangeSlider',
        label: 'Distância Percorrida',
        measure: 'unidades',
        min: 0,
        max: 150,
        validations: {
            required: false
        },
        columnSize: 12
      },
      {
        name: 'name',
        type: 'text',
        label: 'Nome',
        validations: {
          required: false
        },
        columnSize: 6
      },
      {
        name: 'hour',
        type: 'time',
        label: 'Hora',
        validations: {
            required: false
        },
        columnSize: 6
      }, 
      {
        name: 'address',
        type: 'address',
        googleMap: true,
        label: 'Endereço',
        validations: {
            required: false
        },
        columnSize: 12
      },
    ],
    ...formPaths,
    ...labels
  }
  list.form = form;

  return (
    <div>
      <CustomListContainer
        pathAdd={list.pathAdd}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        list={list}
        form={form}
        content={<CustomList list={list} />}
      />
    </div>
  );
}
export default Crud;